import createVisit from './create-visit.json';
import visit from './visit.json';
import visits from './visits.json';

export default {
  visits,
  createVisit,
  visit,
};
